import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import api from '@/lib/api';
import { identify, track } from '@/lib/analytics';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem('jw_token');
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await api.get('/auth/me');
      setUser(data);
    } catch (e) {
      localStorage.removeItem('jw_token');
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('jw_token', data.token);
    setUser(data.user);
    identify();
    track('login');
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post('/auth/register', payload);
    localStorage.setItem('jw_token', data.token);
    setUser(data.user);
    identify();
    track('register');
    return data.user;
  };

  const loginWithSessionId = async (sessionId) => {
    const { data } = await api.post('/auth/google/session', { session_id: sessionId });
    localStorage.setItem('jw_token', data.token);
    setUser(data.user);
    identify();
    track('login', { method: 'google' });
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('jw_token');
    setUser(null);
  };

  const refresh = fetchMe;
  const refreshUser = fetchMe;

  return (
    <AuthContext.Provider value={{ user, loading, login, register, loginWithSessionId, logout, refresh, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
